/* eslint-disable react/prop-types */
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import TextArea from '@zg-rentals/multibrand-ui/lib/TextArea';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import Button from '@zg-rentals/multibrand-ui/lib/Button';
import Link from '@zg-rentals/multibrand-ui/lib/Link';
import pathsManifest from '../../../../../pathsManifest';

import './style.scss';

const REQUIRED_REVIEW_LENGTH = 40;

class ReviewManager extends React.Component {
  getMinimumText = (requiredLength) => {
    const { propertyManagerReview } = this.props;

    if (!propertyManagerReview || propertyManagerReview.length < 1) {
      return `${requiredLength} minimum`;
    } else if (propertyManagerReview.length < requiredLength) {
      return `${requiredLength - propertyManagerReview.length}`;
    } else {
      return '';
    }
  };

  render() {
    const { onBack, onNext, onReviewChange, propertyManagerReview } = this.props;

    return (
      <div className="ReviewManager">
        <div className="stacked-lg">
          <TextArea
            className="ReviewManager-minimum-textarea"
            label="Write a review on the landlord or manager."
            placeholder="What went well or what could have been better with your communication with the property manager or landlord?"
            onChange={onReviewChange}
            value={propertyManagerReview}
          />
          <Text lowlight type="body-small" className="ReviewManager-minimum-text">
            {this.getMinimumText(REQUIRED_REVIEW_LENGTH)}
          </Text>
        </div>

        <div className="ReviewPoperty-nav stacked-lg">
          <Link onClick={onBack} type="secondary">
            Back
          </Link>
          <Button onClick={onNext} type="primary" disabled={propertyManagerReview.length < REQUIRED_REVIEW_LENGTH}>
            Submit
          </Button>
        </div>
        <div>
          <Text lowlight type="body-small">
            By sending this, you confirm our{' '}
            <Link reactRouterLink={RouterLink} to={pathsManifest.propertyReviewGuidelinesPage} type="secondary">
              guidelines
            </Link>{' '}
            and that your statements are based on your personal experience and are truthful.
          </Text>
        </div>
      </div>
    );
  }
}

ReviewManager.defaultProps = {
  onNext: () => {},
  onBack: () => {},
  propertyManagerRating: 0,
  propertyManagerReview: '',
};

export default ReviewManager;
